/** Приведение строк, чисел и т.п. к boolean */
export var parseBool = function (value) {
    if (typeof value === "string") {
        // Приводим строку к нижнему регистру и проверяем на пустоту и 'false'
        return value.trim().toLowerCase() !== "false" && value.trim() !== "";
    }
    // Для всех остальных типов используем стандартное приведение
    return !!value;
};
/** Отформатированная строка => число */
export var numberNormalize = function (value) {
    // Приводим значение к строке, заменяем запятые на точки и удаляем всё, кроме цифр, точек и минусов
    var preparedValue = String(value || "0")
        .replace(/,/g, ".")
        .replace(/[^\d.-]/g, "");
    // Парсим результат в число
    return parseFloat(preparedValue);
};
export var parseEmptyStringToUndefined = function (value) {
    if (!value && value !== 0 && value !== "0")
        return undefined;
    return String(value);
};
export var parseEmptyNumberToUndefined = function (value) {
    if (!value && value !== 0 && value !== "0")
        return undefined;
    return numberNormalize(value);
};
export var parseEmptyString = function (value) {
    if (!value && value !== 0 && value !== "0")
        return "";
    return String(value);
};
